import { Token } from 'config/types'
import { useTranslation } from 'react-i18next'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalProps } from 'UIKit/ModalV2'
import { PAYMENT_MODAL_THEME, StylePaymentModal } from 'views/Payment/MobilePayment/components/styles'
import TokenSelect from './TokenSelect'

type DataProps = {
  onCurrencySelect: (currency: Token) => void
  currencySelected: Token
}
const TokenSelectModal: React.FC<ModalProps<DataProps>> = ({ onDismiss, data }) => {
  const { t } = useTranslation()

  const onCurrencySelect = (currency: Token) => {
    data.onCurrencySelect(currency)
    onDismiss()
  }

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Select Coin')} />
      <ModalBody minHeight="150px" maxHeight="70vh" gap="12px">
        <TokenSelect selectedToken={data.currencySelected} onCurrencySelect={onCurrencySelect} />
      </ModalBody>
    </StylePaymentModal>
  )
}

export default TokenSelectModal
